<template>
  <BaseModalConfirm
    ref="BaseModalConfirmRef"
    image-local="img/welcome-pack/promocode.webp"
    :title="bonusValue"
    :text="$tc('regAuthForgot.regBonus.modal.noDep.text')"
    @close="onClose"
  >
    <template #controls="{ close }">
      <UiBtn :text="$tc('regAuthForgot.regBonus.modal.noDep.alright')" @click="close" />
    </template>
  </BaseModalConfirm>
</template>

<script>
import BaseModalConfirm from '~/components/Base/Modal/Confirm'

export default {
  name: 'RegistrationBonusModalNoDepPromoCodeInfo',
  components: { BaseModalConfirm },
  data() {
    return {
      bonusValue: '',
    }
  },
  methods: {
    $open(bonus) {
      this.bonusValue = bonus?.promotions[0][this.$i18n.locale]?.title || 'Готово!'
      this.$refs.BaseModalConfirmRef.$open()
    },
    onClose() {
      this.bonusValue = ''
    },
  },
}
</script>
